/*
 * @Author: zxf
 * @Date: 2021-12-15 14:26:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-18 20:12:05
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\snap\SnapFeature.js
 */

import SnapActor from "./SnapActor";
import { Tiles } from './../utils/Tiles.js';
import { RenderController } from "../render/RenderController.js";
import {Utils} from "../utils.js";
export default class SnapFeature extends SnapActor{
    constructor(options) {
        super(options);
		this.type = 'SnapFeature';
		this.geoLiveType = options.geoLiveType;
    }

	getPoint(point) {
		const res = { x: point[0], y: point[1] };
		if(point.length == 3) {
			res.z = point[2];
		} 
		return res;
	}

  snap(point,tilesSet) {
    let bounds = this.getSnapBox(point);
    let scenes = this.sceneRegister.scenes;
    let camera = this.scene.getActiveCamera();
    let interactables = [];

    const {tiles} = Tiles.getInstance().getTilesByScreenBox();
    const rolledBackList = [];
    if(this.geoLiveType === 'track' || this.geoLiveType === 'trackPhoto') {
      const renderController = RenderController.getInstance();
      const source = renderController.sourceController.getSource(this.geoLiveType);
      const dataSource = tilesSet||source.getData();
      tiles.forEach(tile => {
        if(dataSource[`${tile.x}_${tile.y}`]) {
          const sourceFlat = dataSource[`${tile.x}_${tile.y}`]
          for(let i=0;i<sourceFlat.length;i++) {
            const geometry = sourceFlat[i].geo;
            const obj = {};
            obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);
            obj.object = sourceFlat[i];
            if(!turf.booleanDisjoint(obj.geo, bounds)) {
              interactables.push(obj);
              break
            }
          }
        }
      })
 
    }else {
      for (let sceneKey in scenes) {
        if(sceneKey != 'feedback') {
          scenes[sceneKey].traverseVisible(node => {
            if (node.visible && !node.isScene && node.prop && this.geoLiveType == node.prop.type) {
              let geometry = node.prop.geo;
              let obj = {};
              obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);
              obj.object = node.prop;

              // 作业圈, 绘制过程中捕捉Polygon边界
              if(geometry.type === 'Polygon') {
                const newGeometry = {
                  type: 'LineString',
                  coordinates: geometry.coordinates[0]
							}
                if(geometry.coordinates[0][0].length ===3) {
                  obj.geo.geometry = Utils.worldVectorToScreenVector(newGeometry, this.domElement, camera).geometry;
                }else {
                  obj.geo.geometry = newGeometry;
                }
                obj.object.geo = newGeometry;
                rolledBackList.push(node);

              }
              if(!turf.booleanDisjoint(obj.geo, bounds)) {
                interactables.push(obj);
              }
            }
          });
        }
      }  
    }
    
    let features = [];
    for(let i = 0; i < interactables.length; i++) {
      const ele = interactables[i];
      let snapPoint = null;
      let distance = 100000;
      let preIndex = -1;
      let nextIndex = -1;
      const coordinates = ele.geo.geometry.coordinates;
      if(ele.geo.geometry.type == 'LineString') {
        const v3Coordinates = ele.object.geo.coordinates;
        const nearPoint = this.gemmetryAlgorithm.getNearPointToLines(coordinates, point);
        distance = nearPoint.distance;
        preIndex = nearPoint.preIndex;
        nextIndex = nearPoint.nextIndex;
        snapPoint = this.gemmetryAlgorithm.getV3PointByV2Point(this.getPoint(coordinates[nearPoint.preIndex]), this.getPoint(coordinates[nearPoint.nextIndex]), nearPoint.point, this.getPoint(v3Coordinates[nearPoint.preIndex]), this.getPoint(v3Coordinates[nearPoint.nextIndex]));
      } else if(ele.geo.geometry.type == 'MultiPoint') {
        snapPoint = this.getPoint(ele.object.geo.coordinates);
				distance = turf.distance(this.getMousePoint({x: coordinates[0][0], y: coordinates[0][1]}), this.getMousePoint(point), {units: 'miles'})
      }
      this.point = snapPoint;
      features.push({
        snapPoint: snapPoint,
        feature: ele.object,
        distance: distance,
        preIndex: preIndex,
        nextIndex: nextIndex,
        type: 'snapFeature'
      });
    }

    for(let i =0;i<rolledBackList.length;i++) {
      rolledBackList[i].prop.geo.type = 'Polygon';
			rolledBackList[i].prop.geo.coordinates = [rolledBackList[i].prop.geo.coordinates]
    }
    return features.length > 0 ? features : null;
    }
}
